import React from 'react';
import SingleDatePickerGit from '@shared/components/CustomDatePicker/index';
import FlightsSearchLayout from '../FlightsSearchLayout';

const OneWay = ({
  airSectionRow,
  setAirSectionRow,
  handleClick,
  showPassengers,
  handleClose,
  flightClass,
  setFlightClass,
  executeSearch,
  hasErrorMessage,
  searchPax,
  setSearchPax,
}) => {
  return (
    <FlightsSearchLayout
      layoutType="oneway"
      components={{
        Left: { md: 8 },
        Middle: {
          component: (
            <SingleDatePickerGit
              dateInfo={value => {
                const newAirSection = [...airSectionRow];
                newAirSection[0].date = value.date_selected;
                setAirSectionRow(newAirSection);
              }}
              datePicked={airSectionRow[0]?.date}
              singleSelect="true"
            />
          ),
          md: 2,
        },
      }}
      {...{
        airSectionRow,
        setAirSectionRow,
        handleClick,
        showPassengers,
        handleClose,
        setFlightClass,
        flightClass,
        executeSearch,
        hasErrorMessage,
        searchPax,
        setSearchPax,
      }}
    />
  );
};

export default OneWay;
